import { render, staticRenderFns } from "./Introduccion.vue?vue&type=template&id=03d6a36e&scoped=true&lang=pug&"
import script from "./Introduccion.vue?vue&type=script&lang=js&"
export * from "./Introduccion.vue?vue&type=script&lang=js&"
import style0 from "./Introduccion.vue?vue&type=style&index=0&id=03d6a36e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6a36e",
  null
  
)

export default component.exports